<ng-container
    *ngIf="{
        products: products$ | async,
        imageOffset: imageOffset$ | async
    } as data"
>
    <div *ngIf="data?.products?.length > 0" lazyLoad (lazyLoad)="onFirstView()">
        <header *ngIf="element && showSliderHeader" class="slider-title">
            <render-wysiwyg
                *ngIf="element.settings?.general?.showTitle && element.settings?.general?.textGridTitle !== null"
                [element]="element"
                [html]="element.settings?.general?.textGridTitle"
            >
            </render-wysiwyg>

            <ng-container *ngIf="arrowPosition === 'header-right'; then sliderArrows"> </ng-container>
        </header>

        <div class="product-component-container">
            <div class="component-inner" [@slider]="data.imageOffset" [ngClass]="{ 'flex-wrap': element.settings?.general?.numberOfRows > 1 }">
                <ng-container *ngFor="let product of productPage$ | async; let index = index; trackBy: trackByProduct">
                    <div class="product-card" [hidden]="!isBrowser && index > _slidesPerPage - 1">
                        <button class="image-link-product" (click)="openLink(product.locationPath)">
                            <img
                                *ngIf="product.productImageData; let imageData"
                                [class]="imageClass"
                                [lazySrc]="imageData"
                                alt="{{ product.name }}"
                            />
                        </button>

                        <div *ngIf="isVisibleName || isVisiblePrice || isVisibleCart || isVisibleButtonLink" class="product-data">
                            <div *ngIf="isVisibleName" class="product-name">
                                <a [href]="product.locationPath">{{ product.name }}</a>
                            </div>
                            <div *ngIf="isVisiblePrice" class="product-price-container">
                                <div *ngIf="product.priceInfo?.priceWithCurrencySymbol" class="product-price-current">
                                    <span class="product-price">
                                        {{ product.priceInfo?.priceWithCurrencySymbol }}
                                    </span>
                                    <span *ngIf="isVisibleOldPrice && product.priceInfo?.oldPriceWithCurrencySymbol" class="old-product-price">
                                        {{ product.priceInfo?.oldPriceWithCurrencySymbol }}
                                    </span>
                                </div>
                                <div *ngIf="product.priceInfo?.localePriceWithCurrencySymbol" class="price-locale-container">
                                    <span class="locale-product-price">
                                        {{ product.priceInfo?.localePriceWithCurrencySymbol }}
                                    </span>
                                    <span
                                        *ngIf="isVisibleOldPrice && product.priceInfo?.oldLocalePriceWithCurrencySymbol"
                                        class="old-locale-product-price"
                                    >
                                        {{ product.priceInfo?.oldLocalePriceWithCurrencySymbol }}
                                    </span>
                                </div>
                            </div>
                            <render-link *ngIf="isVisibleButtonLink" class="button-link-product" [link]="product.link" [element]="element">
                                <render-wysiwyg
                                    [html]="element.settings?.general?.textButtonLink"
                                    [element]="element"
                                    [textPaddingTop]="element.settings?.general?.textPaddingTop"
                                    [textPaddingBottom]="element.settings?.general?.textPaddingBottom"
                                    [textPaddingLeft]="element.settings?.general?.textPaddingLeft"
                                    [textPaddingRight]="element.settings?.general?.textPaddingRight"
                                >
                                </render-wysiwyg>
                            </render-link>
                        </div>
                    </div>
                </ng-container>
            </div>

            <ng-container *ngIf="arrowPosition === 'inside-left-right'; then sliderArrows"> </ng-container>

            <ng-container *ngIf="displayComponentPager && isScrollPager">
                <div class="component-slider">
                    <ng-container *ngIf="_totalPages > maxBulletPages">{{ _currentPage }} / {{ _totalPages }}</ng-container>
                    <ul
                        *ngIf="_totalPages <= maxBulletPages"
                        class="pagination"
                        [ngClass]="{
                            'pager-style-dot': isPagerStyleDot,
                            'pager-style-box': isPagerStyleBox,
                            'pager-style-solid': isPagerStyleSolid,
                            'pager-style-dashed': isPagerStyleDashed
                        }"
                    >
                        <li *ngFor="let page of _totalPagesArr; let i = index; trackBy: trackByIndex" class="pagination-link">
                            <button (click)="goToSlide(i, data.imageOffset)" [ngClass]="{ active: currentSlide === i }"></button>
                        </li>
                    </ul>
                </div>
            </ng-container>
        </div>
    </div>

    <ng-template #sliderArrows>
        <div *ngIf="displayComponentArrows && isScrollPager" class="component-arrows arrow-control">
            <button
                (click)="prevSlide(data.imageOffset)"
                class="arrow-left"
                [class.no-border-button]="arrowPosition === 'header-right'"
                [disabled]="_isFirstSlide"
            >
                <svg class="swiper-arrow" viewBox="0 0 11 16" fill="none">
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M3.82242 8L10.6154 14.532L9.08879 16L0.769231 8L9.08879 -8.65753e-07L10.6154 1.46796L3.82242 8Z"
                    />
                </svg>
            </button>
            <button
                (click)="nextSlide(data?.imageOffset)"
                class="arrow-right"
                [class.no-border-button]="arrowPosition === 'header-right'"
                [disabled]="_isLastSlide"
            >
                <svg class="swiper-arrow" viewBox="0 0 11 16" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.79296 8L0 1.46796L1.5266 0L9.84615 8L1.5266 16L0 14.532L6.79296 8Z" />
                </svg>
            </button>
        </div>
    </ng-template>
</ng-container>
